import React, {Component} from "react";
import DefaultPage from "./DefaultPage";

class NewsPage extends Component
{
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <DefaultPage
                    title={this.props.title}
                    subtitle={this.props.subtitle}
                    leftSide={this.props.leftSide}
                    rightSide={this.props.rightSide}
                />
            </>
        );
    }
}

export default NewsPage;
